"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ModulePopup = _interopRequireDefault(require("./components/ModulePopup.vue"));
var _mobileContent = _interopRequireDefault(require("./mobileContent"));
var _creatApp = require("@/api/creatApp");
var _personalCenter = require("@/api/operationManagement/personalCenter");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    MobileContent: _mobileContent.default,
    ModulePopup: _ModulePopup.default
  },
  props: {},
  data: function data() {
    return {
      activeNum: 0,
      baseData: [{
        isShow: 0,
        tableData: [{
          name: '背景图片',
          size: '750*304',
          type: 'bgUrl',
          url: ''
        }, {
          name: '文字色值',
          size: '',
          type: 'textColor',
          color: ''
        }, {
          name: '客服图标',
          size: '80*80',
          type: 'customerServiceIcon',
          url: '',
          text: '客服'
        }, {
          name: '导师图标',
          size: '80*80',
          type: 'teacher',
          url: '',
          text: '导师'
        }, {
          name: '消息图标',
          size: '80*80',
          type: 'msgIcon',
          url: '',
          text: '消息'
        }, {
          name: '设置图标',
          size: '80*80',
          type: 'turnIcon',
          url: '',
          text: '设置'
        }],
        text: '个人中心顶部模块',
        key: 1
      }, {
        isShow: 0,
        tableData: [{
          name: '左侧logo',
          size: '80*80',
          type: 'leftLogo',
          url: ''
        }, {
          name: '',
          size: '',
          type: 'firstTextColor',
          color: '',
          text: 'firstText'
        }, {
          name: '',
          size: '',
          type: 'secondTextColor',
          color: '',
          text: 'secondText'
        }, {
          name: '右侧按钮背景颜色',
          size: '',
          type: 'rightBtnColor',
          color: ''
        }, {
          name: '右侧按钮文字颜色',
          size: '',
          type: 'rightBtnTextColor',
          color: ''
        }, {
          name: '背景图片',
          size: '690*690',
          type: 'bgUrl',
          url: ''
        }],
        text: '升级提示模块',
        key: 2
      }, {
        isShow: 0,
        tableData: [{
          name: '每月结算日期提示',
          size: '',
          type: 'explain',
          color: ''
        }, {
          name: '每月结算提示背景',
          size: '',
          type: 'explainBg',
          color: ''
        }, {
          name: '收益明细按钮色值',
          size: '',
          type: 'detailedBtn',
          color: ''
        }, {
          name: '收益明细文字色值',
          size: '',
          type: 'detailedText',
          color: ''
        }, {
          name: '去提现按钮色值',
          size: '',
          type: 'cashBtn',
          color: ''
        }, {
          name: '去提现文字色值',
          size: '',
          type: 'cashText',
          color: ''
        }, {
          name: '数据展示模块背景色值',
          size: '',
          type: 'bgColor',
          color: ''
        }, {
          name: '数据展示模块文字色值',
          size: '',
          type: 'textColor',
          color: ''
        }],
        text: '数据展示模块',
        key: 3
      }, {
        isShow: 0,
        tableData: [],
        text: '',
        key: 4
      }, {
        isShow: 0,
        tableData: [],
        text: '中部轮播图',
        key: 5,
        category: 1
      }, {
        isShow: 0,
        tableData: [{
          name: '模块图片',
          size: '690*65',
          type: 'sharePic',
          url: ''
        }],
        text: '分享宣传模块',
        key: 6
      }, {
        isShow: 0,
        tableData: [],
        text: '底部轮播图',
        key: 7,
        category: 2
      }, {
        isShow: 0,
        tableData: [],
        text: '',
        key: 8
      }],
      tableData: [{
        name: '背景色',
        size: '',
        type: 'bgColor',
        color: ''
      }, {
        name: '文字色值',
        size: '',
        type: 'textColor',
        color: ''
      }, {
        name: '客服图标',
        size: '180*180',
        type: 'customerServiceIcon',
        url: '',
        text: '客服'
      }, {
        name: '消息图标',
        size: '180*180',
        type: 'msgIcon',
        url: '',
        text: '消息'
      }, {
        name: '设置图标',
        size: '180*180',
        type: 'turnIcon',
        url: '',
        text: '设置'
      }],
      secondData: [{
        name: '结算说明色值',
        size: '',
        type: 'explain',
        color: '',
        bstop: 'true'
      }, {
        name: '收益明细按钮色值',
        size: '',
        type: 'detailedBtn',
        color: '',
        bstop: 'true'
      }, {
        name: '收益明细字体色值',
        size: '',
        type: 'detailedText',
        color: '',
        bstop: 'true'
      }, {
        name: '去提现按钮色值',
        size: '',
        type: 'cashBtn',
        color: '',
        bstop: 'true'
      }, {
        name: '去提现字体色值',
        size: '',
        type: 'cashText',
        color: '',
        bstop: 'true'
      }]
    };
  },
  computed: {
    // homeTopList() {
    //   return this.tableData
    // },
    // centerList() {
    //   return this.secondData
    // },
    allCenterConfig: function allCenterConfig() {
      return this.baseData;
    }
  },
  mounted: function mounted() {
    var _this = this;
    (0, _personalCenter.findConfigAll)().then(function (res) {
      if (res.data) {
        _this.baseData.map(function (i) {
          if (i.key === 4) {
            i.tableData = res.data.filter(function (i) {
              return i.configGroupCode === 'centerFourCard';
            });
          } else if (i.key === 8) {
            i.tableData = res.data.filter(function (i) {
              return i.configGroupCode !== 'centerFourCard';
            });
          }
        });
      }
    });
    this.findAll();
    this.getList();
    setTimeout(function () {
      _this.dataBuff();
    }, 500);
  },
  methods: {
    findAll: function findAll() {
      var _this2 = this;
      (0, _creatApp.findAll)({
        region: 5
      }).then(function (res) {
        if (res.data.length === 0) {
          _this2.initData();
        } else {
          _this2.baseData.map(function (m) {
            res.data.map(function (i) {
              if (i.category * 1 === m.category) {
                m.isShow = i.enable;
                m.tableData = i.bannerList;
                m['id'] = i.id;
              }
            });
          });
        }
      });
    },
    initData: function initData() {
      var _this3 = this;
      var arr = this.baseData.filter(function (i) {
        return i.category;
      }).map(function (i) {
        return {
          modelName: i.text,
          locations: [],
          category: i.category,
          backgroundMode: '',
          backgroundContent: '',
          enable: i.isShow
        };
      });
      console.log(arr);
      (0, _creatApp.initBannerModel)({
        region: 5,
        items: arr
      }).then(function () {
        _this3.findAll();
      });
    },
    changeStatus: function changeStatus(val) {
      var _this4 = this;
      this.$confirm(val.isShow === 0 ? '确定关闭此模块?' : '确定开启此模块?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        if (val.category) {
          (0, _creatApp.updateBannerModelStatus)({
            id: val.id,
            enable: val.isShow
          }).then(function () {
            _this4.findAll();
            _this4.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          });
        } else {
          (0, _creatApp.saveSetting)({
            appId: _this4.$store.getters.appId,
            itemKey: "userCenter_".concat(val.key),
            itemValue: JSON.stringify(_this4.baseData.filter(function (i) {
              return i.key === val.key;
            })[0])
          }).then(function (res) {
            _this4.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          });
        }
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消'
        });
        if (val.isShow === 1) {
          val.isShow = 0;
        } else {
          val.isShow = 1;
        }
      });
    },
    setting: function setting(val) {
      var _this5 = this;
      console.log(val);
      if (val.key === 4) {
        this.$confirm('编辑四连块和服务位请去首页-运营管理-个人中心配置', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this5.$router.push({
            path: '/operationManagement/personalCenter'
          });
        }).catch(function () {
          _this5.$message({
            type: 'info',
            message: '已取消'
          });
        });
      } else if (val.key === 5 || val.key === 7) {
        this.$refs.ModulePopup.open({
          name: '个人中心' + val.text,
          id: val.id,
          region: 5,
          category: val.category
        });
      } else {
        this.activeNum = val.key;
      }
    },
    getList: function getList() {
      var _this6 = this;
      var arr = [];
      this.baseData.map(function (i) {
        arr.push("userCenter_".concat(i.key));
      });
      (0, _creatApp.getConfigList)({
        appId: this.$store.getters.appId,
        itemKeyList: arr
      }).then(function (res) {
        if (res.data) {
          res.data.map(function (i) {
            if (JSON.parse(i.itemValue)) {
              _this6.baseData.map(function (m) {
                if (m.key === JSON.parse(i.itemValue).key) {
                  // console.log(m.tableData, JSON.parse(i.itemValue).tableData)
                  var slefArr = [];
                  m.tableData.map(function (h) {
                    if (!JSON.parse(i.itemValue).tableData.some(function (obj) {
                      return obj.type === h.type;
                    })) {
                      // 判断本地数据和数据库数据是否一致，如果不一致代表本地有新增的配置项
                      // console.log(h, '这是我 新添加的')
                      slefArr.push(h);
                    }
                  });
                  // console.log(JSON.parse(i.itemValue).tableData, '马上要赋值', slefArr)
                  m.tableData = JSON.parse(i.itemValue).tableData.concat(slefArr);
                  m.isShow = JSON.parse(i.itemValue).isShow;
                  m.text = JSON.parse(i.itemValue).text;
                }
              });
            }
          });
        }
      });
    },
    handleChildData: function handleChildData(val) {
      var _this7 = this;
      console.log(val);
      if (val === 4) {
        this.$confirm('编辑四连块和服务位请去首页-运营管理-个人中心配置', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this7.$router.push({
            path: '/operationManagement/personalCenter'
          });
        }).catch(function () {
          _this7.$message({
            type: 'info',
            message: '已取消'
          });
        });
      } else if (val === 5 || val === 7) {
        this.baseData.map(function (i) {
          if (i.key === val) {
            _this7.$refs.ModulePopup.open({
              name: '个人中心' + i.text,
              id: i.id,
              region: 5,
              category: i.category
            });
          }
        });
      } else {
        this.activeNum = val;
      }
    },
    save: function save() {
      var _this8 = this;
      (0, _creatApp.saveSetting)({
        appId: this.$store.getters.appId,
        itemKey: "userCenter_".concat(this.activeNum),
        itemValue: JSON.stringify(this.baseData.filter(function (i) {
          return i.key === _this8.activeNum;
        })[0])
      }).then(function (res) {
        _this8.$notify.success({
          title: '温馨提示',
          message: '操作成功'
        });
      });
    },
    dataBuff: function dataBuff() {
      // 确保第一次进来可以刷新子组件
      this.tableData.splice(0, 0);
      this.secondData.splice(0, 0);
      this.baseData.splice(0, 0);
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref, val, text) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              if (text) {
                val[text] = pictureUrl;
              } else {
                val.url = pictureUrl;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      function handleFileUpload(_x, _x2, _x3) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    del: function del(val, text) {
      var _this9 = this;
      this.$confirm('是否确认要删除该图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this9.$notify.success({
          title: '温馨提示',
          message: '成操作成功'
        });
        if (text) {
          val[text] = '';
        } else {
          val.url = '';
        }
      }).catch(function () {
        _this9.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
};